interface FilterCheckboxProps {
  label: string;
  count: number;
  checked: boolean;
  onChange: () => void;
  className?: string;
}

export default function FilterCheckbox({
  label,
  count,
  checked,
  onChange,
  className = "",
}: FilterCheckboxProps) {
  return (
    <div className={`relative py-1 ${className}`}>
      <label className="flex cursor-pointer items-center">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className="w-4 h-4 text-gray-50 accent-[#126798] rounded-md focus:ring-0"
        />
        <span
          className={`ml-2 font-roboto font-normal text-[15px] ${
            checked ? "text-[#1680bc]" : "text-gray-500"
          }`}
        >
          {label} ({count})
        </span>
      </label>
    </div>
  );
}
